import { downloadCsv } from "@/pages/people/_utils/downloadCsv";

export const columnHeaders = [
  "First Name",
  "Last Name",
  "Email",
  "Phone",
  "Resume Link",
  "Average Review Score",
  "Decision",
  "Lead Consultant Notes"
];

const decisionMapping = ["Decline", "Consider", "Advance"];

const parseDecision = (score: number) => {
  if (score === null) return "";
  return decisionMapping[score - 1];
};

const csvCell = (value: unknown) => (value == null || value === "" ? "" : String(value));

export const generateColumnData = (applications: any, includeReviews: boolean = true) => {
  return applications.map((application: any) => {
    const leadConsultantReview = application.reviews?.find((review: any) => review.isRecommendation === true);
    const decision = leadConsultantReview ? parseDecision(leadConsultantReview.score) : "";
    const leadConsultantNotes = leadConsultantReview?.comments || "";

    return [
      csvCell(application.applicant?.firstName),
      csvCell(application.applicant?.lastName),
      csvCell(application.email),
      csvCell(application.phone),
      csvCell(application.resume),
      ...(includeReviews
        ? [csvCell(application.reviewScoreAverage), csvCell(decision), csvCell(leadConsultantNotes)]
        : [])
    ];
  });
};

export function exportApplicantReviewsCsv(applications: any[], jobTitle: string, facilityName: string) {
  const timestamp = Date.now();
  const sanitizedJobTitle = jobTitle.trim().replace(/\s+/g, "-");
  const sanitizedFacilityName = facilityName.trim().replace(/\s+/g, "-");
  const filename = `${sanitizedJobTitle}-${sanitizedFacilityName}-Application-Reviews-${timestamp}.csv`;

  downloadCsv([columnHeaders, ...generateColumnData(applications)], filename);
}
